import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { InfinitePaginatorResourceService, InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'
import { Nullable } from '@/shared/types/app.types'
import { ColDef, ColGroupDef } from '@ag-grid-community/core'

export abstract class StatisticalAnalysisDatasource<T> implements InfinitePaginatorResourceService<T> {
    abstract paginator(filterModel: CommonFilterModel, params: CommonParams, ...restOfParams: any[]): Promise<InfinitePaginatorResponse<T>>
    abstract getGridColumns(): (ColDef | ColGroupDef | ExportedColDef | ExportedColGroupDef)[]
}

export abstract class StatisticalAnalysisDatasourceExternalDetail<T> extends StatisticalAnalysisDatasource<T> {
    protected totalElements: Nullable<number>

    public getTotalElements(): Nullable<number> {
        return this.totalElements
    }

    public setTotalElements(totalElements: Nullable<number>): void {
        this.totalElements = totalElements
    }

    abstract getLabAndCaseId(selectedRow: T): [number, Nullable<number>]
}
